import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("绑定")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("微盟消费明细")
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "itme-box" }
const _hoisted_5 = { class: "h-table" }
const _hoisted_6 = { class: "h-tr h-tr-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("view", { class: "h-td" }, "购买渠道：", -1)
const _hoisted_8 = { class: "h-td" }
const _hoisted_9 = { class: "h-tr h-tr-2" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("view", { class: "h-td" }, "消费单号：", -1)
const _hoisted_11 = { class: "h-td" }
const _hoisted_12 = { class: "h-tr h-tr-3" }
const _hoisted_13 = { class: "h-td h-td-colspan h-td-rowspan" }
const _hoisted_14 = { class: "h-tr h-tr-4" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("view", { class: "h-td" }, "商品分类", -1)
const _hoisted_16 = { class: "h-td h-td-colspan" }
const _hoisted_17 = { class: "h-tr h-tr-4" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("view", { class: "h-td" }, "商品名称", -1)
const _hoisted_19 = { class: "h-td h-td-colspan" }
const _hoisted_20 = { class: "h-tr h-tr-2" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("view", { class: "h-td" }, "数量", -1)
const _hoisted_22 = { class: "h-td" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("view", { class: "h-td" }, "金额", -1)
const _hoisted_24 = { class: "h-td" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("伯俊消费明细")
const _hoisted_26 = { class: "content" }
const _hoisted_27 = { class: "itme-box" }
const _hoisted_28 = { class: "h-table" }
const _hoisted_29 = { class: "h-tr h-tr-2" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("view", { class: "h-td" }, "购买渠道：", -1)
const _hoisted_31 = { class: "h-td" }
const _hoisted_32 = { class: "h-tr h-tr-2" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("view", { class: "h-td" }, "消费日期：", -1)
const _hoisted_34 = { class: "h-td" }
const _hoisted_35 = { class: "h-tr h-tr-3" }
const _hoisted_36 = { class: "h-td h-td-colspan h-td-rowspan" }
const _hoisted_37 = { class: "h-tr h-tr-4" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("view", { class: "h-td" }, "商品分类", -1)
const _hoisted_39 = { class: "h-td h-td-colspan" }
const _hoisted_40 = { class: "h-tr h-tr-4" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("view", { class: "h-td" }, "商品名称", -1)
const _hoisted_42 = { class: "h-td h-td-colspan" }
const _hoisted_43 = { class: "h-tr h-tr-2" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("view", { class: "h-td" }, "数量", -1)
const _hoisted_45 = { class: "h-td" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("view", { class: "h-td" }, "金额", -1)
const _hoisted_47 = { class: "h-td" }
const _hoisted_48 = { class: "h-tr h-tr-2" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("view", { class: "h-td" }, "颜色", -1)
const _hoisted_50 = { class: "h-td" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("view", { class: "h-td" }, "尺码", -1)
const _hoisted_52 = { class: "h-td" }

import { reactive, ref, onMounted, computed } from 'vue';
import { useRoute, useRouter } from "vue-router"
import tools from '@/tools'

import { useUserStore } from '@/store/user'
import request from '@/plugin/request'
import work from '@/plugin/work'

import { Toast } from 'vant';


export default /*#__PURE__*/_defineComponent({
  __name: 'customer',
  setup(__props) {

const customer = reactive({
  user_id: '',
  mobile: '',
  info: {
    weimob: [

    ],
    burgeon: [],
  } as any,
  weimob: [
    { title: '来源', key: 'STORENAME', align: 'center' },
    { title: '日期', key: 'BILLDATE', align: 'center' },
    { title: '分类', key: 'NAME', align: 'center' },
    { title: '商品', key: 'VALUE', align: 'center' },
    { title: '金额', key: 'QTY', align: 'center' },
  ],
  burgeon: [
    { title: '来源', key: 'STORENAME', align: 'center' },
    { title: '日期', key: 'BILLDATE', align: 'center' },
    { title: '分类', key: 'CATEGORY', align: 'center' },
    { title: '商品', key: 'VALUE', align: 'center' },
    { title: '数量', key: 'QTY', align: 'center' },
    { title: '颜色', key: 'VALUE1', align: 'center' },
    { title: '款号', key: 'VALUE2', align: 'center' },
  ],
  query: () => {
    request('/work/func/customer', { user_id: customer.user_id,mobile:customer.mobile }, { method: 'POST', loading: true }).then(res => {
      if (res.result.mobile) {
        customer.mobile = res.result.mobile
        customer.info = res.result

      }
    })
  }
})

const mobile = ref('')

const jsApiList = [
  'getContext',
  'getCurExternalContact',
  'selectExternalContact',
  'selectEnterpriseContact',
  'sendChatMessage'
]

onMounted(async () => {

  const url = location.href.split("#")[0].split("?")[0]
  work.wecom.register({
    corpId: 'ww28471c5a45fa1161',
    agentId: 1000002,
    jsApiList: jsApiList,
    async getAgentConfigSignature(url) {
      const res: any = await request('/work/login/agent', { mod: 'assistant', url: url }, { method: 'POST' })
      const { timestamp, nonceStr, signature } = res.result
      // Notify({ type: 'success', message: '授权成功', })
      return { timestamp, nonceStr, signature }
    },
    onAgentConfigSuccess() {

      work.wecom.invoke('getCurExternalContact', {
      }, function (res: any) {

        if (res.errMsg == "getCurExternalContact:ok") {

          customer.user_id = res.userId

          customer.query()

        } else {
          //错误处理
        }
      });

    }

  })


})


return (_ctx: any,_cache: any) => {
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_divider = _resolveComponent("van-divider")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_van_cell_group, null, {
      default: _withCtx(() => [
        _createVNode(_component_van_field, {
          modelValue: customer.mobile,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((customer.mobile) = $event)),
          center: "",
          clearable: "",
          label: "手机号",
          placeholder: "请输入手机号绑定会员"
        }, {
          button: _withCtx(() => [
            _createVNode(_component_van_button, {
              size: "small",
              type: "primary",
              onClick: customer.query
            }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_van_cell_group, null, {
      default: _withCtx(() => [
        _createVNode(_component_van_field, {
          label: "姓名",
          "model-value": customer.info.name,
          readonly: "",
          "input-align": "right"
        }, null, 8, ["model-value"]),
        _createVNode(_component_van_field, {
          label: "昵称",
          "model-value": customer.info.nick,
          readonly: "",
          "input-align": "right"
        }, null, 8, ["model-value"]),
        _createVNode(_component_van_field, {
          label: "性别",
          "model-value": customer.info.sex,
          readonly: "",
          "input-align": "right"
        }, null, 8, ["model-value"]),
        _createVNode(_component_van_field, {
          label: "生日",
          "model-value": customer.info.birthday,
          readonly: "",
          "input-align": "right"
        }, null, 8, ["model-value"]),
        _createVNode(_component_van_field, {
          label: "关爱日期",
          "model-value": customer.info.care_date,
          readonly: "",
          "input-align": "right"
        }, null, 8, ["model-value"]),
        _createVNode(_component_van_field, {
          label: "开卡门店",
          "model-value": customer.info.shop_name,
          readonly: "",
          "input-align": "right"
        }, null, 8, ["model-value"]),
        _createVNode(_component_van_field, {
          label: "微盟余额",
          "model-value": customer.info.currentAmount,
          readonly: "",
          "input-align": "right"
        }, null, 8, ["model-value"]),
        _createVNode(_component_van_field, {
          label: "积分余额",
          "model-value": customer.info.currentPoint,
          readonly: "",
          "input-align": "right"
        }, null, 8, ["model-value"])
      ]),
      _: 1
    }),
    _createVNode(_component_van_divider, null, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customer.info.weimob, (order) => {
      return (_openBlock(), _createElementBlock("view", _hoisted_3, [
        _createElementVNode("view", _hoisted_4, [
          _createElementVNode("view", _hoisted_5, [
            _createElementVNode("view", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("view", _hoisted_8, _toDisplayString(order.channelTypeName), 1)
            ]),
            _createElementVNode("view", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("view", _hoisted_11, _toDisplayString(order.orderNo), 1)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(order.itemList, (item) => {
              return (_openBlock(), _createElementBlock("view", _hoisted_12, [
                _createElementVNode("view", _hoisted_13, [
                  _createElementVNode("view", _hoisted_14, [
                    _hoisted_15,
                    _createElementVNode("view", _hoisted_16, _toDisplayString(item.primaryCategory), 1)
                  ]),
                  _createElementVNode("view", _hoisted_17, [
                    _hoisted_18,
                    _createElementVNode("view", _hoisted_19, _toDisplayString(item.goodsTitle), 1)
                  ]),
                  _createElementVNode("view", _hoisted_20, [
                    _hoisted_21,
                    _createElementVNode("view", _hoisted_22, _toDisplayString(item.skuNum), 1),
                    _hoisted_23,
                    _createElementVNode("view", _hoisted_24, _toDisplayString(item.totalAmount), 1)
                  ])
                ])
              ]))
            }), 256))
          ])
        ])
      ]))
    }), 256)),
    _createVNode(_component_van_divider, null, {
      default: _withCtx(() => [
        _hoisted_25
      ]),
      _: 1
    }),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customer.info.burgeon, (order) => {
      return (_openBlock(), _createElementBlock("view", _hoisted_26, [
        _createElementVNode("view", _hoisted_27, [
          _createElementVNode("view", _hoisted_28, [
            _createElementVNode("view", _hoisted_29, [
              _hoisted_30,
              _createElementVNode("view", _hoisted_31, _toDisplayString(order.storeName), 1)
            ]),
            _createElementVNode("view", _hoisted_32, [
              _hoisted_33,
              _createElementVNode("view", _hoisted_34, _toDisplayString(order.billDate), 1)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(order.detail, (item) => {
              return (_openBlock(), _createElementBlock("view", _hoisted_35, [
                _createElementVNode("view", _hoisted_36, [
                  _createElementVNode("view", _hoisted_37, [
                    _hoisted_38,
                    _createElementVNode("view", _hoisted_39, _toDisplayString(item.category), 1)
                  ]),
                  _createElementVNode("view", _hoisted_40, [
                    _hoisted_41,
                    _createElementVNode("view", _hoisted_42, _toDisplayString(item.product), 1)
                  ]),
                  _createElementVNode("view", _hoisted_43, [
                    _hoisted_44,
                    _createElementVNode("view", _hoisted_45, _toDisplayString(item.qty), 1),
                    _hoisted_46,
                    _createElementVNode("view", _hoisted_47, _toDisplayString(item.total), 1)
                  ]),
                  _createElementVNode("view", _hoisted_48, [
                    _hoisted_49,
                    _createElementVNode("view", _hoisted_50, _toDisplayString(item.color), 1),
                    _hoisted_51,
                    _createElementVNode("view", _hoisted_52, _toDisplayString(item.size), 1)
                  ])
                ])
              ]))
            }), 256))
          ])
        ])
      ]))
    }), 256))
  ], 64))
}
}

})